import React, { useState } from 'react'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogContentSize,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Spinner } from '@/components/ui/spinner'
import { cn } from '@/lib/utils'

interface ConfirmationModalProps {
  visible: boolean
  onYes: () => void | Promise<void>
  onCancel?: () => void
  yesButtonText?: string
  cancelButtonText?: string
  contentText?: string
  renderTitle?: React.ReactNode
  hideFooter?: boolean
  onClose?: () => void
  size?: DialogContentSize
  variant?: 'default' | 'destructive' | 'success'
  className?: string
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = (props) => {
  const {
    visible,
    yesButtonText,
    cancelButtonText,
    contentText,
    renderTitle: Title,
    variant,
  } = props
  const [isLoading, setLoading] = useState<boolean>(false)

  const resolvedVariant =
    variant ??
    (yesButtonText && /delete|remove|reject/i.test(yesButtonText) ? 'destructive' : 'success')

  const handleYesClick = async () => {
    setLoading(true)
    await props.onYes()
    setLoading(false)
  }

  const handleNoClick = () => {
    props.onCancel && props.onCancel()
  }

  const renderTitle = () => {
    return contentText || Title
  }

  return (
    <Dialog open={visible} onOpenChange={props.onClose || handleNoClick}>
      <DialogContent
        size={props.size}
        overlayClassName='z-2060'
        className={cn('z-2060', props.className)}
      >
        <DialogHeader>
          <DialogTitle>Confirmation</DialogTitle>
          <DialogDescription>{renderTitle()}</DialogDescription>
        </DialogHeader>

        <DialogFooter>
          {!!handleNoClick && (
            <DialogClose
              render={<Button variant='outline'>{cancelButtonText || 'Cancel'}</Button>}
            />
          )}
          <Button onClick={handleYesClick} disabled={isLoading} variant={resolvedVariant}>
            {yesButtonText ? yesButtonText : 'Yes, close.'}
            {isLoading && <Spinner />}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default ConfirmationModal
